import toast from "react-hot-toast";

export function handleError(err) {
    if(typeof err.response.data.message == 'object'){
        (err.response.data.message || []).forEach((message)=> {
            toast.error(message)
        })
    }
}

export function showsuccesToast(message = "") {
    if(message){
        toast(message, {
            icon: '  ✅',
            style: {borderRadius: '10px', background: '#333', color: '#fff'},
        });
    }
}